"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FLAG_FROM_LOG_META_SYM = void 0;
exports.FLAG_FROM_LOG_META_SYM = Symbol("FlagFromLogMeta");
//# sourceMappingURL=FlagFromLogMeta.js.map